<div class="form-group">
  <label
    class="form-label"
    [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }"
  >
    {{ title }}

    <span *ngIf="isRequired" class="astrix-red">*</span>
  </label>
  <div
    [translatable]="{
      transKey: placeholderTranslationKey,
      modEnum: placeholderTranslationModuleEnum
    }"
  >
    <textarea
      (blur)="focus()"
      (input)="change()"
      [disabled]="disabled"
      [(ngModel)]="value"
      [placeholder]="placeholder"
      class="form-textarea w-100"
      [ngClass]="{ valid: control?.valid }"
    ></textarea>
  </div>
</div>
<ng-container *ngIf="!!showValidations">
  <app-validation
    *ngIf="(control?.touched || isSubmitted) && control?.invalid"
    [title]="title"
    [control]="control"
    [length]="length"
    [minLength]="minLength"
    [valideMax]="validMax"
    [maxLength]="maxLength"
  ></app-validation>
</ng-container>
